import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, isAdminRole } from "../context/AuthContext";

export function RequireAuth({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        <div className="flex items-center gap-2">
          <span className="h-2 w-2 rounded-full bg-foreground/60 animate-typing-dot" />
          <span
            className="h-2 w-2 rounded-full bg-foreground/60 animate-typing-dot"
            style={{ animationDelay: "0.15s" }}
          />
          <span
            className="h-2 w-2 rounded-full bg-foreground/60 animate-typing-dot"
            style={{ animationDelay: "0.3s" }}
          />
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (adminOnly && !isAdminRole(user.role)) return <Navigate to="/" replace />;

  return children;
}
